import type { ReactNode } from "react";
import { authJourneyStyles as styles } from "./auth-journey";

export interface FirstRunStep {
  title: string;
  description: string;
}

/**
 * Presentation-only first-run checklist. Membership persistence is deliberately
 * supplied by the caller so this component can be reused by each role.
 */
export function FirstRunChecklist({
  steps,
  actions,
}: {
  steps: FirstRunStep[];
  actions?: ReactNode;
}) {
  return (
    <div className={styles.firstRun}>
      {steps.map((step, index) => (
        <div className={styles.firstRunItem} key={`${index}-${step.title}`}>
          <span className={styles.firstRunNumber} aria-hidden="true">
            {index + 1}
          </span>
          <div>
            <div className={styles.firstRunTitle}>{step.title}</div>
            <div className={styles.firstRunDescription}>{step.description}</div>
          </div>
        </div>
      ))}
      {actions}
    </div>
  );
}
